@if (!media.isActive('lt-md')) {
  <app-chart-rank-items
    chartName="Tiktok"
    [infos]="tiktokWeeklyInfo$ | async"
    [dataCollections]="dataCollections$ | async"
  ></app-chart-rank-items>
}
@if (media.isActive('lt-md')) {
  <app-sp-chart-rank-items
    chartName="Tiktok"
    [infos]="tiktokWeeklyInfo$ | async"
    [dataCollections]="dataCollections$ | async"
  ></app-sp-chart-rank-items>
}
